/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('store.filterUpdate', function (data) {
        var cards = data.fetchFindReplaceData.source.querySelectorAll('.storeCard--product');
        animate(cards);
    });
    MoyaEventHandler.on('store.filters-toggled-open', function (data) {
        var openElement = data.toggle.getOpenElement();
        var buttonElement = openElement.querySelector('button.moya-select--title');
        if (buttonElement !== null) {
            buttonElement.click();
        }
    });
    MoyaEventHandler.on('store.filters-toggled-close', function (data) {
        var openElement = data.toggle.getOpenElement();
        var buttonElement = openElement.querySelector('button.moya-select--title');
        if (buttonElement !== null) {
            buttonElement.click();
        }
    });
    MoyaEventHandler.on('store.shouldRunFilter', function (data) {
        var event = data.event;
        if (event.target.classList.contains('moya-select--search-input') || event.target.classList.contains('radioSearch')) {
            data.shouldFindAndReplace = false;
        }
    });
    function animate(cards) {
        var delayStep = 100;
        var delay = 0;
        cards.forEach(function (card) {
            card.classList.remove('fade-in');
            setTimeout(function () {
                card.classList.add('fade-in');
            }, delay += delayStep);
        });
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
